import { formattingMonth } from '../../../common/utils/date';

export const createDataForLinks = (count: number, date: string) => {
  const { href: urlForSocial } = window.location;

  return [
    {
      name: 'tg',
      url: `https://t.me/share/url?url=${urlForSocial}&text=Топ-${count} агентств недвижимости на Циан по итогам ${formattingMonth(
        date,
      )} года&utm_source=share2`,
    },
    {
      name: 'vk',
      url: `https://vk.com/share.php?url=${urlForSocial}&title=Топ-${count} агентств недвижимости на Циан по итогам ${formattingMonth(
        date,
      )} года&utm_source=share2`,
    },
    {
      name: 'wh',
      url: `https://api.whatsapp.com/send?text=Топ-${count} агентств недвижимости на Циан по итогам ${formattingMonth(
        date,
      )} года — Представляем ежемесячный рейтинг агенств недвижимости ${urlForSocial}&utm_source=share2`,
    },
    {
      name: 'ok',
      url: `https://connect.ok.ru/offer?url=${urlForSocial}&utm_source=share2`,
    },
  ];
};
